import { Cookies } from 'react-cookie';

import { SRBMMonitoringHistoryData } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getSRBMMonitoringHistory = async (slug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/v1/srbm/${slug}/period-signals`, {
    headers: {
      Authorization: token,
    },
  });
  return data.data as SRBMMonitoringHistoryData[];
};
